import React, { useEffect, useState } from "react";
import general from "../styles/General.module.scss";
import { useGlobalContext } from "../contextProvider/ContextProvider";
import { getApiBase } from "../config/runtimeConfig";

const Rechnungsadresse = ({ handleInputChange, inputSummary }) => {
  const apiBase = getApiBase();
  const [newAgbs, setNewAgbs] = useState("");
  const { agbs } = useGlobalContext();

  useEffect(() => {
    // check if agbs exists and if so, replace the "public" within the string with "storage"
    if (agbs) {
      const editedAgbs = agbs.replace("public", "storage");
      setNewAgbs(`${apiBase}/${editedAgbs}`);
    }
  }, [agbs, apiBase]);

  return (
    <>
      <div
        className={general.rechungWrapper}
        style={{ display: "flex", gap: "100px" }}
      >
        <div className="choices-container">
          <div
            className={`${general.inputContainer} ${"choices-container"} ${
              general.flexRow
            }`}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="radio"
                id="tax"
                name="tax"
                value="Privat"
                onChange={(e) =>
                  handleInputChange("tax", e.target.value, "radio")
                }
                className={`${general.radioButtons + " required"}`}
                checked={inputSummary["tax"] === "Privat"}
              />
              <label htmlFor="tax" style={{ margin: "0" }}>
                Privat*
              </label>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="radio"
                id="tax"
                name="tax"
                value="Gewerblich"
                onChange={(e) =>
                  handleInputChange("tax", e.target.value, "radio")
                }
                className={`${general.radioButtons + " required"}`}
                checked={inputSummary["tax"] === "Gewerblich"}
              />
              <label htmlFor="tax" style={{ margin: "0" }}>
                Gewerblich*
              </label>
            </div>
          </div>

          {inputSummary["tax"] === "Gewerblich" ? (
            <div className={general.inputContainer}>
              <label htmlFor="firma">Firma*</label>
              <input
                type="text"
                name="firma"
                onChange={(e) => handleInputChange("firma", e.target.value)}
                value={inputSummary["firma"]}
                className={`${general.mediumInput + " required"}`}
                style={{ marginBottom: "25px" }}
              />
              <div className="choices-container">
                <div className={`${general.inputContainer} ${general.flexRow}`}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <input
                      type="radio"
                      id="bauleistender"
                      name="bauleistender"
                      value="true"
                      onChange={(e) =>
                        handleInputChange(
                          "bauleistender",
                          e.target.value,
                          "radio"
                        )
                      }
                      className={`${general.radioButtons + " required"}`}
                      checked={inputSummary["bauleistender"] === "true"}
                    />
                    <label
                      htmlFor="bauleistender"
                      style={{ margin: "0", fontSize: "17px" }}
                    >
                      Bauleistender i.S.v. §13b UstG. Die Vergütung versteht
                      sich ohne USt. (Umkehr der Umsatz Steuerschuldnerschaft).
                      Zum Nachweis übergibt der Auftraggeber dem Auftragnehmer
                      eine gültige USt 1 TG nach §13b UstG.*
                    </label>
                  </div>
                </div>

                <div className={`${general.inputContainer} ${general.flexRow}`}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <input
                      type="radio"
                      id="kein.bauleistender"
                      name="bauleistender"
                      value="false"
                      onChange={(e) =>
                        handleInputChange(
                          "bauleistender",
                          e.target.value,
                          "radio"
                        )
                      }
                      className={`${general.radioButtons + " required"}`}
                      checked={inputSummary["bauleistender"] === "false"}
                    />
                    <label
                      htmlFor="kein.bauleistender"
                      style={{ margin: "0", fontSize: "17px" }}
                    >
                      Kein Bauleistender i.S.v. §13b UstG. Die Vergütung
                      versteht sich zzgl. Ust.*
                    </label>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <div className={general.inputContainer}>
            <label htmlFor="vorname">Vorname*</label>
            <input
              type="text"
              name="vorname"
              onChange={(e) => handleInputChange("vorname", e.target.value)}
              value={inputSummary["vorname"]}
              className={`${general.mediumInput + " required"}`}
            />
          </div>

          <div className={general.inputContainer}>
            <label htmlFor="nachname">Nachname*</label>
            <input
              type="text"
              name="nachname"
              onChange={(e) => handleInputChange("nachname", e.target.value)}
              value={inputSummary["nachname"]}
              className={`${general.mediumInput + " required"}`}
            />
          </div>

          <div className={general.inputContainer}>
            <label htmlFor="telefonnummer">Telefonnummer*</label>
            <input
              type="text"
              name="telefonnummer"
              onChange={(e) =>
                handleInputChange("telefonnummer", e.target.value)
              }
              value={inputSummary["telefonnummer"]}
              className={`${general.mediumInput + " required"}`}
            />
          </div>

          <div className={general.inputContainer}>
            <label htmlFor="email">E-Mail Adresse*</label>
            <input
              type="email"
              name="email"
              onChange={(e) => handleInputChange("email", e.target.value)}
              value={inputSummary["email"]}
              className={`${general.mediumInput + " required"}`}
            />
          </div>
        </div>

        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              paddingBottom: "25px",
            }}
          >
            <input
              type="checkbox"
              id="wieBaustellenadresse"
              name="wieBaustellenadresse"
              onChange={(e) =>
                handleInputChange(
                  "wieBaustellenadresse",
                  e.target.value,
                  "checkbox",
                  e.target.checked,
                  true
                )
              }
              className={general.checkboxes}
              checked={inputSummary["wieBaustellenadresse"] === true} // Use true or false directly
            />
            <label htmlFor="wieBaustellenadresse" style={{ margin: "0" }}>
              Wie Baustellenadresse
            </label>
          </div>

          <div className={general.inputContainer}>
            <label htmlFor="strasse">Straße/Hausnummer*</label>
            <input
              type="text"
              name="strasse-rechnungsadresse"
              onChange={(e) =>
                handleInputChange("strasse-rechnungsadresse", e.target.value)
              }
              value={
                inputSummary["wieBaustellenadresse"] === true
                  ? inputSummary["strasse-baustellenadresse"]
                  : inputSummary["strasse-rechnungsadresse"]
              }
              disabled={inputSummary["wieBaustellenadresse"] === true}
              className={`${general.mediumInput + " required"}`}
            />
          </div>

          <div className={general.inputContainer}>
            <label htmlFor="plz">PLZ*</label>
            <input
              type="text"
              name="plz-rechnungsadresse"
              onChange={(e) =>
                handleInputChange("plz-rechnungsadresse", e.target.value)
              }
              style={{ maxWidth: "80px" }}
              value={
                inputSummary["wieBaustellenadresse"] === true
                  ? inputSummary["plz-baustellenadresse"]
                  : inputSummary["plz-rechnungsadresse"]
              }
              disabled={inputSummary["wieBaustellenadresse"] === true}
              className={`${general.smallInput + " required"}`}
            />
          </div>

          <div className={general.inputContainer}>
            <label htmlFor="ort">Ort*</label>
            <input
              type="text"
              name="ort-rechnungsadresse"
              onChange={(e) =>
                handleInputChange("ort-rechnungsadresse", e.target.value)
              }
              value={
                inputSummary["wieBaustellenadresse"] === true
                  ? inputSummary["ort-baustellenadresse"]
                  : inputSummary["ort-rechnungsadresse"]
              }
              disabled={inputSummary["wieBaustellenadresse"] === true}
              className={`${general.mediumInput + " required"}`}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              paddingBottom: "25px",
            }}
            className="choices-container"
          >
            <input
              type="checkbox"
              id="acceptTerms"
              name="acceptTerms"
              onChange={(e) =>
                handleInputChange(
                  "acceptTerms",
                  e.target.value,
                  "checkbox",
                  e.target.checked,
                  true
                )
              }
              className={`${general.checkboxes + " required"}`}
              checked={inputSummary["acceptTerms"] === true}
            />
            <label
              htmlFor="acceptTerms"
              style={{ margin: "0", width: "350px" }}
            >
              Hiermit akzeptiere ich die{" "}
              <a
                href={newAgbs}
                target="_blank"
                rel="noreferrer"
                className={general.underline}
              >
                AGB
              </a>{" "}
              und{" "}
              <a
                href="https://pedotherm-fraessystem.de/datenschutz/"
                target="_blank"
                rel="noreferrer"
                className={general.underline}
              >
                Datenschutzbestimmungen.
              </a>
              *
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default Rechnungsadresse;
